import { render, staticRenderFns } from "./appBoards.vue?vue&type=template&id=7057263a&scoped=true"
import script from "./appBoards.vue?vue&type=script&lang=js"
export * from "./appBoards.vue?vue&type=script&lang=js"
import style0 from "./appBoards.vue?vue&type=style&index=0&id=7057263a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7057263a",
  null
  
)

export default component.exports